/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Supports_StreamingInputs */



/**
* | output |
* | --- |
* | "Supports Streaming" |
*
* @param {Private_Models_Form_Supports_StreamingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_supports_streaming = /** @type {((inputs?: Private_Models_Form_Supports_StreamingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Supports_StreamingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstützt Streaming")
	return /** @type {LocalizedString} */ ("Supports Streaming")
});